<template>
  <div class="whyChooseUs">
    <div class="head c-f">
      <div class="pl42 pr42">
        <div class="pt112 f54 lh74 fw800">{{ t("why_choose_us.title") }}</div>
        <div class="pt22 f28 lh40 titleIntro">{{ t("why_choose_us.title_intro") }}</div>
      </div>
    </div>
    <ul class="ml40 mr40 pl50 pr50 pt80 pb40 bg-f f28 mb48 introUl">
      <li class="list pb50" v-for="(item, index) in items" :key="index">
        <div class="pb26 lh44">
          <img class="ico" :src="ico" alt="">
          <p class="pl6 pt4 f32 fw500 c-0 txt">{{t(`why_choose_us.ul.li${index+1}.t1`)}}</p>
        </div>
        <div class="ot8 pb8 flex-sb ac">
          <p class="c-3 f28 lh40 listIntro">{{t(`why_choose_us.ul.li${index+1}.t2`)}}</p>
          <img class="listIco" :src="item" alt="">
        </div>
      </li>
    </ul>
    <!-- <div class="pt48 pb50 ta-c lh34 f24 c-gray6">{{t("why_choose_us.concat")}}</div> -->
  </div>
</template>

<script>
import { onMounted, reactive,toRefs } from "vue";
import { useI18n } from "vue-i18n";
import ico from '@/assets/images/whyChooseUs/ico.png'
import ico1 from '@/assets/images/whyChooseUs/ico1.png'
import ico2 from '@/assets/images/whyChooseUs/ico2.png'
import ico3 from '@/assets/images/whyChooseUs/ico3.png'
import ico4 from '@/assets/images/whyChooseUs/ico4.png'
export default {
  name: "WhyChooseUs",
  setup() {
    const { t } = useI18n();
    const state = reactive({
      items:[ico1,ico2,ico3,ico4]
    });
    onMounted(() => {
      document.title = t("why_choose_us.title");
    });

    return {
      ...toRefs(state),
      t,
      ico
    };
  },
};
</script>

<style lang="stylus" scoped>
@import './style.styl';
</style>